import RadioGroup from './group/RadioGroup'
import { RadioGroupInput } from './group/RadioGroupInput'

const Radio = {
  Group: RadioGroup,
  GroupInput: RadioGroupInput,
}

export default Radio
